import React, { useEffect } from 'react'

import { DateRangeFilter } from './SearchFilter/DateRangeFilter'

import { WorkOrderReportFilters } from '../../../interfaces/WorkOrder/WorkOrderReportDashboard'
import { Button, Grid, InputLabel, MenuItem, Select } from '@mui/material'
import { SelectChangeEvent } from '@mui/material/Select'
import { TypeDate } from '../../../enums/eTypeDate'

import { PaperPanel } from '../../UI'
import { useWarehouses } from '../../../hooks'

interface WorkOrderDashboardFiltersProps {
  handleSearch: (event: React.ChangeEvent<HTMLInputElement>) => void
  handleChangeDateType: (dateType: TypeDate) => void
  handleChangeWarehouse: (
    event: SelectChangeEvent<string>
  ) => void
  values: WorkOrderReportFilters
}

export const WorkOrderDashboardFilters: React.FC<
  WorkOrderDashboardFiltersProps
> = ({ values, handleSearch, handleChangeDateType, handleChangeWarehouse }) => {
  const handleButtonColor = (buttonType: TypeDate) =>
    values.type === buttonType ? 'primary' : 'inherit'

  const {
    getWarehouses,
    warehousesState: { warehouses }
  } = useWarehouses()

  useEffect(() => {
    if (warehouses?.length === 0) {
      getWarehouses()
    }
  }, [])

  return (
    <PaperPanel>
      <Grid container spacing={3} direction='row'>
        <Grid item xs={12} sm={2} spacing={5}>
          <Button
            color={handleButtonColor(TypeDate.CourierDeliveryDateTime)}
            fullWidth
            variant='contained'
            onClick={() =>
              handleChangeDateType(TypeDate.CourierDeliveryDateTime)
            }
          >
            Fecha Entrega
          </Button>
        </Grid>
        <Grid item xs={12} sm={2} spacing={5}>
          <Button
            color={handleButtonColor(TypeDate.CreatedAtDateTime)}
            variant='contained'
            fullWidth
            onClick={() => handleChangeDateType(TypeDate.CreatedAtDateTime)}
          >
            Creada
          </Button>
        </Grid>
        <Grid item xs={12} sm={2} spacing={5}>
          <Button
            color={handleButtonColor(TypeDate.AllCreatedNotFinished)}
            fullWidth
            variant='contained'
            onClick={() => handleChangeDateType(TypeDate.AllCreatedNotFinished)}
          >
            Pendiente
          </Button>
        </Grid>
      </Grid>

      <div
        style={{
          display: 'flex',
          justifyContent: 'space-evenly',
          flexWrap: 'wrap',
          marginTop: '30px',
          width: '100%'
        }}
      >
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            width: '60%'
          }}
        >
          <DateRangeFilter
            handleSearch={handleSearch}
            initialDate={values.initialDate}
            finalDate={values.finalDate}
            isValid={values.isValid}
            isShowed={!(values.type === TypeDate.AllCreatedNotFinished)}
          />
        </div>

        <div
          style={{
            width: '20%'
          }}
        >
          <InputLabel>Almacén</InputLabel>
          <Select
            fullWidth
            onChange={handleChangeWarehouse}
            value={values.warehouseId}
          >
            <MenuItem value={0}>Seleccione Almacén...</MenuItem>
            {warehouses?.map((warehouse) => (
              <MenuItem value={warehouse.id}>
                {warehouse.warehouseName}
              </MenuItem>
            ))}
          </Select>
        </div>
      </div>
    </PaperPanel>
  )
}
